import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MenuItem, ConfirmationService, Message, SelectItem } from 'primeng/primeng';
import { FuncaoExercidaPrestacaoConta } from 'app/entity/funcao-exercida_prestacao_conta.model';
import { AtividadeFuncaoExercida } from 'app/entity/atividade-funcao-exercida.model';
import { PadraoService } from '../service/padrao.service';
import { BaseComponent } from './base.component';

@Component({ template: '' })
export class BaseCrudComponent extends BaseComponent implements OnInit {
    cadastro: FormGroup;
    obj: any;
    filtro: FormGroup;

    funcaoExercidaPrestacaoConta: FuncaoExercidaPrestacaoConta = new FuncaoExercidaPrestacaoConta;
    listFuncaoExercidaPrestacaoConta: FuncaoExercidaPrestacaoConta[] = [];
    
    atividadeFuncaoExercidaCurso: AtividadeFuncaoExercida = new AtividadeFuncaoExercida;
    listAtividadeFuncaoExercida: AtividadeFuncaoExercida[] = [];

    @Input() listaFuncao: any[] = [];

    funcaoExercida: SelectItem[] = [];

    id: number;
    acao: string;
    id_params: string;

    showEtapas: boolean = false;

    disableAutoLoad: boolean = false;

    etapa: number = 0;
    etapas: MenuItem[] = [
        { label: 'Dados' },
        { label: 'Resumo' }
    ];

    dateValidation: RegExp = /(((\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2}))([+-](\d{2})\:(\d{2}))?Z?z?)/;
    listaUsuario: any[];
    ngOnInit() {

        this.init();
        this.activatedRoute.params.subscribe(params => { 
            this.id = params['id'];
            this.id_params = params['id'];
            var listaLink = location.href.split("/")
            var caminho = listaLink[5] + '/' + listaLink[6];
            if (caminho === "turma/editar" || caminho === "turma/editar-homologacao") {
                this.acao = 'turma-editar';
            } else if (caminho === "turma/prestar-conta" || caminho === "turma/prestar-conta-homologacao") {
                this.acao = 'turma-prestar-conta'
            } else if (caminho === "turma/turma-visualizar" || caminho === "turma/turma-visualizar-homologacao") {
                this.acao = 'turma-visualizar'
            }
            else if (caminho === "prestacao-conta/simular") {
                this.acao = "simular";
            }
            else if(caminho === 'prazo-prestacao-conta/profissionais-pendentes'){
                this.etapa = 2;
            }
            else if (listaLink[6] == "homologar") {
                this.acao = "homologar";
            }

            else if (caminho === "edicao-evento/edicao-visualizar" || caminho === "edicao-evento/edicao-visualizar-homologacao") {
                this.acao = 'edicao-visualizar'
            } else if (caminho === "edicao-evento/prestar-conta" || caminho === "edicao-evento/prestar-conta-homologacao" || caminho === "edicao-evento/prestar-conta-individual" || caminho === "edicao-evento/prestar-conta-individual-homologacao") {
                this.acao = 'edicao-prestar-conta'
            } else if (caminho === "edicao-evento/editar" || caminho === "edicao-evento/editar-homologacao") {
                this.acao = 'edicao-editar'
            } else if (caminho === "homologacao-capacitadora/alterar-responsavel-homologacao") {
                this.acao = 'alterar-responsavel'
            } else {
                this.acao = (params['acao'] !== undefined ? params['acao'] : "cadastrar").toLowerCase();
            }
            switch (this.acao) {
                case 'homologar':
                    this.loadObject();
                    break;
                case 'visualizar':
                    this.etapa = (this.etapas.length - 1);
                    this.cadastro.disable();
                case 'enviar-cadastro':
                    this.etapa = (this.etapas.length - 1);
                case 'alterar-responsavel':
                    this.loadObject();
                    break;
                case 'abrir-recurso':
                    this.etapa = 0;
                    this.loadObject();
                    break
                case 'editar':
                    this.loadObject();
                    break;
                case 'simular':
                    this.loadObject();
                    break;
                case 'turma-prestar-conta':
                    if (!this.disableAutoLoad) {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Obter('turma', this.id).subscribe(obj => {
                            Object.keys(obj).forEach(key => {
                                obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                            });
                            this.obj = obj;
                            this.cadastro.patchValue(obj);
                            this.afterLoad();
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                    };
                    break;
                case 'edicao-prestar-conta':
                    if (!this.disableAutoLoad) {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Obter('edicaoEvento/GetObterV2', params['id']).subscribe(obj => {
                            if (typeof obj === 'string')
                                obj = JSON.parse(obj); 
                            Object.keys(obj).forEach(key => {
                                obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                            });
                            this.obj = obj;
                            this.cadastro.patchValue(obj);
                            this.afterLoad();
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                    };
                    break;
                case 'turma-editar':
                    if (!this.disableAutoLoad) {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Obter('turma', this.id).subscribe(obj => {
                            Object.keys(obj).forEach(key => {
                                obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                            });
                            this.obj = obj;
                            this.cadastro.patchValue(obj);
                            this.afterLoad();
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                    };
                    break;
                case 'edicao-editar':
                    if (!this.disableAutoLoad) {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Obter('edicaoEvento', this.id).subscribe(obj => {
                            Object.keys(obj).forEach(key => {
                                obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                            });
                            this.obj = obj;
                            this.cadastro.patchValue(obj);
                            this.afterLoad();
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                    };
                    break;
                case 'turma-visualizar':
                    if (!this.disableAutoLoad) {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Obter('turma', this.id).subscribe(obj => {
                            Object.keys(obj).forEach(key => {
                                obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                            });
                            this.obj = obj;
                            this.cadastro.patchValue(obj);
                            this.afterLoad();
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                    };
                    break;
                case 'edicao-visualizar':
                    if (!this.disableAutoLoad) {
                        this.observableUtilPanelDoc.setBlockedPanel(true);
                        this.service.Obter('edicaoEvento/GetObterV2', this.id).subscribe(obj => {
                            if (typeof obj === 'string')
                                obj = JSON.parse(obj); 
                            Object.keys(obj).forEach(key => {
                                obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                            });
                            this.obj = obj;
                            this.cadastro.patchValue(obj);
                            this.afterLoad();
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        });
                    };
                    break;
            };
        });
        this.afterInit();
    };
    loadObject() {
        if (!this.disableAutoLoad && this.controllerName != "") {
            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.service.Obter(this.controllerName, this.id).subscribe(obj => {
                Object.keys(obj).forEach(key => {
                    obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                });
                this.obj = obj;
                this.cadastro.patchValue(obj);
                this.afterLoad();
            },
                err => {
                    this.showMsgError(`Erro ao obter registro. ${err._body}`);
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                },
                () => this.observableUtilPanelDoc.setBlockedPanel(false));
        };
    }

    doFinalAction(obj: any, route: string = null) {
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, os dados serão ${this.acao === 'cadastrar' ? 'salvos' : 'atualizados'} na base de dados.<br>Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.acao === 'cadastrar' ?
                    this.service.Adicionar(route == null ? this.controllerName : route, obj).subscribe(() => {
                        this.showMsgSucess('Registro salvo com sucesso.');
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                    },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            if (err.status === 412) {
                                super.showMsgWarn(`Atenção!<br> ${err._body}`)
                                return this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                            }
                            super.showMsgError(`Houve um erro ao salvar o registro.<br> ${err._body}`)
                        }) :
                    this.service.Atualizar(route == null ? this.controllerName : route, obj).subscribe(() => {
                        this.showMsgSucess('Registro atualizado com sucesso.');
                        this.router.navigate(['../../'], { relativeTo: this.activatedRoute })
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            this.showMsgError(`Houve um erro ao atualizar o registro.<br> ${err._body}`)
                        });
            }
        });
    }

    buscarListaUsuario(codigo: string) {
        if (this.etapa == 0) {
            this.service.ListarTodosUsuarios("usuario", "Comissão CRC", `CRC-${codigo.substring(0, 2)}`).subscribe(
                data => {
                    return this.listaUsuario = data;
                }, err => {
                    this.showMsgError("Erro ao carregar usuária, favor recarregar a página.");
                }
            );
        }
        else if (this.etapa == 2) {
            this.service.ListarTodosUsuarios("usuario", "Comissão CFC", "CFC").subscribe(
                data => {
                    return this.listaUsuario = data;
                }, err => {
                    this.showMsgError("Erro ao carregar usuario, favor recarregar a página.");
                }
            );
        }
    }

    obterSiglaLotacao(codigo: string) {
        var sigla = codigo.split('-')[0];
        if ((this.etapa === 0 || this.etapa === 1) && sigla !== "CF") {
            return "CRC-" + sigla;
        }
        return "CFC";
    }
}



// WEBPACK FOOTER //
// ./src/app/base/base-crud.component.ts